import {structureRefTypes, dataRefTypes} from '../../utils/refStructureUtils'
export const namespacesWithoutTypeAndId = new Set([
    'documentServicesModel',
    'coBranding',
    'rendererModel',
    'wixCode',
    'deletedPagesMap',
    'appsState',
    'appsInstallState',
    'basedOnSignature',
    'save',
    'contactFormsMetaData',
    'serviceTopology',
    'pagesPlatformApplications',
    'commonConfig',
    'wixCodeUndoable',
    'platform',
    'testType',
    'renderFlags',
    'semanticAppVersions',
    'renderRealTimeConfigPointer',
    'runtime',
    'svgShapes',
    'wixCodeWaitForApproval',
    'displayedOnlyComponents',
    'ghostStructure',
    'mobile',
    'blocksPreviewData',
    'viewerRuntime',
    'partners',
    'ghostControllers',
    'multilingual',
    'activeVariants',
    'DESKTOP-ref',
    'customElementsPointer',
    'documentServiceModel',
    'orphanPermanentDataNodes',
    //further check needed on:
    'atomicScopes',
    'devSiteAppDefId',
    'draftAppName',
    'appStudioModel',
    'lastBuildId',
    'remoteStructureMetaData',
    'builderCompAppData',
    ...structureRefTypes,
    ...dataRefTypes
])
